/**
 * Interface for providing data to the cs-roller component.
 * Implement this abstract class to provide list data to the roller.
 */
export abstract class CsRollerListInterface {
  /**
   * Returns the total number of elements in the list.
   */
  abstract getTotalElements(): number;

  /**
   * Returns the display text for the element at the given index.
   * @param index The index of the element (0-based)
   */
  abstract getElement(index: number): string;
}